import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * <cooking-methods>
 *
 * Displays the cooking-method icons/labels for the currently selected variant.
 * On every variant change the product section is re-rendered server-side; this
 * component pulls its fresh markup out of that re-render and morphs itself,
 * matching the pattern used by <product-inventory>.
 */
class CookingMethods extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateCookingMethods);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateCookingMethods);
  }

  /**
   * @param {CustomEvent} event - The variant update event.
   */
  updateCookingMethods = (event) => {
    // Keep product id in sync for combined listings, and ignore events for other products.
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newMarkup = event.detail.data.html?.querySelector('cooking-methods');
    if (!newMarkup) return;

    // Reflect the empty/non-empty state, then morph the children.
    if (newMarkup.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }

    morph(this, newMarkup, { childrenOnly: true });
  };
}

if (!customElements.get('cooking-methods')) {
  customElements.define('cooking-methods', CookingMethods);
}
